<div class="vol-tab">
  <p class="tab-state" *ngIf="loading">{{ 'common.loading' | translate }}</p>
  <p class="tab-state error" *ngIf="!loading && error">{{ 'audiences.volumes.error' | translate }}</p>
  <p class="tab-state" *ngIf="!loading && !error && !hasData">{{ 'audiences.volumes.empty' | translate }}</p>

  <ng-container *ngIf="!loading && !error && hasData">
    <app-audience-volumes-trend-chart [volumesData]="trend"></app-audience-volumes-trend-chart>

    <div class="vol-tab__exports" *ngIf="exportBoxes.length">
      <div class="export-box" *ngFor="let box of visibleBoxes; trackBy: trackByKey">
        <div class="export-box__label">
          <span class="export-box__name" [title]="box.name">{{ box.name }}</span>
          <span class="export-box__entity" *ngIf="box.entity" [title]="box.entity">{{ box.entity }}</span>
        </div>
        <span class="export-box__value">{{ formatNumber(box.volume) }}</span>
      </div>

      <button type="button" class="tab-more" *ngIf="hasMore" (click)="toggleShowAll()">
        {{ (showAll ? 'audiences.volumes.showLess' : 'audiences.volumes.showMore') | translate }}
      </button>
    </div>
  </ng-container>
</div>
